// import request from '@/utils/request'

// // 示例
// export default function login(data) {
//    return request({
//      url: '/login',  
//      method: 'post',
//      data: data
//    })
// }

import http from '@/utils/http'
import storage from '@/utils/storage'

/**
 *  @parms resquest 请求地址 例如：http://197.82.15.15:8088/request/...
 *  @param '/testIp'代表vue-cil中config，index.js中配置的代理
 */
let resquest = "/tgy"

// get请求
export default {

    //获取短信验证码
    getCodeAPI(params) {
        storage.setToken('') //设置请求头值
        return http.get(`${resquest}/aliyun/sendSmsForLogin`, params)
    },

    //账号密码登录 + 手机号码注册 type认证类型，1-账号密码登录/2-账号快捷登录/3-账号注册
    loginAPI(params) {
        storage.setToken('Basic YnJvd3Nlcjo=') //设置请求头值
        return http.post(`${resquest}/oauth/token`, params)
    },

    //找回密码
    changePasswordAPI(params) {
        //设置请求头值
        storage.setToken('') //设置请求头值
        return http.post(`${resquest}/mobile/user/changePassword`, params);
    },

    //微信一键登录
    loginCallbackAPI(params) {
        //设置请求头值
        storage.setToken('') //设置请求头值
        return http.get(`${resquest}/wx/login/callback`, params);
    },

    //手机号是否已注册
    checkRegisterAPI(params) {
        //设置请求头值
        storage.setToken('') //设置请求头值
        return http.post(`${resquest}/oauth/checkRegister`, params);
    },

    // ***********************首页界面-我的模块**********************

    //首页-轮播图
    bannerAPI(params) {
        //设置请求头值
        storage.setToken('') //设置请求头值
        return http.post(`${resquest}/mobile/banner`, params)
    },

    //场地中心-列表
    siteUserH5ListAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/site/userH5/list`, params)
    },

    //场地中心-查看
    siteUserH5DetailAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/site/userH5/detail`, params)
    },

    //场地中心-查看-预约看房
    reservationSaveVisitAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/reservationVisit/save`, params)
    },

    //场地中心-查看-相似房源
    pxalikeAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/pc/site/userPC/alike/list`, params)
    },

    //场地中心-查看-改楼盘其他房源
    pclistBySiteSupplierIdAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/pc/site/userPC/else/listBySiteSupplierId`, params)
    },

    //场地中心-查看-标记收藏
    collectAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/site/userH5/collect`, params)
    },

    //场地中心-已收藏列表
    collectListAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/site/userH5/collect/list`, params)
    },

    //帮我找场地-保存
    demandSaveAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/demand/save`, params)
    },

    //帮我找场地-编辑
    demanAddAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/demand/add`, params)
    },

    // ***********************用户界面-我的模块**********************

    //申请场地-入驻申请-保存
    siteSupplierApplySaveAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/siteSupplier/apply/save`, params)
    },

    //申请场地-入驻申请-获取场地类型
    siteSupplierApplyAddAPI(params) {
        storage.setToken('') //设置请求头值
        return http.post(`${resquest}/mobile/siteSupplier/apply/add`, params)
    },

    //申请场地-入驻申请-查看
    siteSupplierApplyDetailAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/siteSupplier/apply/detail`, params)
    },

    //个人设置-超级会员-保存
    distributorApplySaveAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/distributorApply/save`, params)
    },

    //个人设置-超级会员-保存
    protocolManualAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/protocolManual/userH5/detail`, params)
    },

    //优惠券-列表
    couponListAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/coupon/list`, params)
    },

    //优惠券-领券
    couponCollectSaveAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/couponCollect/save`, params)
    },

    //优惠券-领券记录
    couponCollectListByUserIdAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/couponCollect/listByUserId`, params)
    },

    //我的预约
    reservationVisitListAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/reservationVisit/list`, params)
    },

    //个人设置-保存
    personalSettingsSaveAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/user/personalSettings/save`, params)
    },

    //个人设置-查看
    changePortraitDetailAPI(params) {
        //alert('storage.setUserInfo'+JSON.stringify(storage.getUserInfo()))
        console.log('storage.setUserInfo'+JSON.stringify(storage.getUserInfo()))
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/user/personalSettings/detail`, params)
    },

    //个人设置-头像变更
    changePortraitAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/user/changePortrait`, params)
    },

    //个人主页
    getLoginUserInfo(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/userH5/index`, params)
    },

    // ***********************分销中心模块**********************

    //分销中心-主页
    distributorIndexAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/distributor/index`, params)
    },

    //分销中心-申请提现
    userH5ApplySaveAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/cashout/userH5/apply/save`, params)
    },

    //分销中心-提现明细
    userH5ApplyListAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/cashout/userH5/list`, params)
    },

    //分销中心-分销佣金
    userH5ApplyCashAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/cashout/userH5/cash`, params)
    },

    //分销中心-支付订单
    userH5ApplyPayListAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/orderInfo/userH5/paymentOrder/list`, params)
    },

    //分销中心-我的顾客
    userH5ApplyCustomerAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/user/userH5/myCustomers/list`, params)
    },

    // ***********************订单页面管理模块**********************

    //上门预约-类型
    reservationOnSiteAddAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/reservationOnSite/add`, params)
    },

    //上门预约-保存
    reservationOnSiteSaveAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/reservationOnSite/save`, params)
    },

    //订单-列表
    orderInfoUserH5ListAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/orderInfo/userH5/list`, params)
    },


    //订单-计算应付金额
    calcOrderTotalPriceAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/orderInfo/calcOrderTotalPrice`, params)
    },

    //订单-编辑
    orderInfoUserH5AddAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/orderInfo/userH5/add`, params)
    },

    //订单-保存
    orderInfoUserH5SaveAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/orderInfo/userH5/save`, params)
    },

    //订单-查看
    orderInfoDetailAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/orderInfo/detail`, params)
    },

    //订单-取消订单
    orderInfoUserH5CancelAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/orderInfo/userH5/cancel`, params)
    },

    //订单-退款订单
    orderInfoUserH5RefundAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/orderInfo/userH5/refund`, params)
    },

    //订单-资料补齐
    orderInfoUserH5SupplementSaveAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/orderInfo/userH5/supplement/save`, params)
    },

    //订单-合同浏览
    contractuserH5DetailAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/contract/userH5/detail`, params)
    },

    //订单-评价
    orderInfoUserH5AppraiseAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/orderInfo/userH5/appraise`, params)
    },

    //订单-删除
    orderInfoUserH5DeleteAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/orderInfo/userH5/delete`, params)
    },

    //订单-下载合同
    orderInfoUserH5DownloadZipAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/contract/userH5/downloadZip`, params)
    },

    //订单-订单编辑
    orderInfoUserH5UploadAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/orderInfo/siteSupplierH5/update`, params)
    },
    
    // ***********************场地方界面模块**********************

    //场地方管理-列表
    siteListBySiteSupplierIdAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/site/listBySiteSupplierId`, params)
    },

    //场地方管理-编辑
    siteAddAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/site/add`, params)
    },

    //场地方管理-保存
    siteSaveAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/site/save`, params)
    },

    //场地方管理-查看
    siteDetailAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/site/detail`, params)
    },

    //场地方管理-删除
    siteDeleteAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/site/delete`, params)
    },

    //场地方管理-上下架
    siteShelfStatusAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/site/shelfStatus`, params)
    },

    //场地方管理-复制
    siteCopyAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/site/copy`, params)
    },

    //客户管理-列表
    customerManagementListAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/user/siteSupplier/customerManagement/list`, params)
    },

    //客户管理-保存
    customerManagementSaveAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/user/siteSupplier/customerManagement/save`, params)
    },

    //客户管理-查看
    customerManagementDetailAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/user/siteSupplier/customerManagement/detail`, params)
    },

    //员工管理-列表
    employeeManagementListAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/user/siteSupplier/employeeManagement/list`, params)
    },

    //员工管理-性别列表
    employeeManagementAddAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/user/siteSupplier/employeeManagement/add`, params)
    },

    //员工管理-保存
    employeeManagementSaveAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/user/siteSupplier/employeeManagement/save`, params)
    },

    //员工管理-查看
    employeeManagementDetailAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/user/siteSupplier/employeeManagement/detail`, params)
    },

    //员工管理-删除
    employeeManagementDeleteAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/user/siteSupplier/employeeManagement/delete`, params)
    },

    //账号设置-查看
    siteSupplierAccountSettingsDetailAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/user/siteSupplier/accountSettings/detail`, params)
    },

    //账号设置-保存
    siteSupplierAccountSettingsSaveAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/user/siteSupplier/accountSettings/save`, params)
    },

    //账号设置-绑定微信号
    wxPayAuthorizeAPI(params) {
        return http.get(`${resquest}/wx/authorize`, params)
    },

    //预约管理-列表
    siteSupplierListAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/reservationVisit/siteSupplier/list`, params)
    },

    //预约管理-标记跟进
    reservationVisitUpdateStatusAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/reservationVisit/updateStatus`, params)
    },

    //预约管理-上门预约列表
    doorSupplierListAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/reservationOnSite/siteSupplier/list`, params)
    },
    
    //预约管理-上门预约标记跟进
    doorVisitUpdateStatusAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/reservationOnSite/updateStatus`, params)
    },

    //合同管理-列表
    contractListBySiteSupplierIdAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/contract/listBySiteSupplierId`, params)
    },

    //订单管理-列表
    listBySiteSupplierIdAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/orderInfo/listBySiteSupplierId`, params)
    },

    //订单管理-上传合同
    contractSaveAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/contract/save`, params)
    },

    //订单管理-立即接单
    siteSupplierTakeAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/orderInfo/siteSupplierH5/take`, params)
    },

    //首页-场地方主页
    siteSupplierIndexAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/siteSupplier/index`, params)
    },

    //财务管理-申请提现
    siteSupplierApplyAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/cashout/siteSupplierH5/apply/save`, params)
    },

    //财务管理-提现记录
    siteSupplierApplyHistoryAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/cashout/siteSupplierH5/finance/list`, params)
    },

    //财务管理-流水详情
    siteSupplierWithDrawDetailAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/orderInfo/siteSupplierH5/finance/detail`, params)
    },

    //财务管理-流水列表
    siteSupplierFlowListAPI(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/pc/revenueExpenditure/siteSupplierH5/finance/list`, params)
    },

    //消息管理-消息列表
    getNoticeList(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/msg/userH5/list`, params)
    },

    //消息管理-消息已阅
    readNoticeInfo(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/msg/userH5/updateReadstatus`, params)
    },

    // ***********************附件上传模块**********************

    //单附件上传
    uploadSingleFileAPI(params) {
        return http.post(`${resquest}/mobile/attachment/uploadSingleFile`, params)
    },

    //多附件上传
    uploadMultipartFileAPI(params) {
        return http.post(`${resquest}/mobile/attachment/uploadMultipartFile`, params)
    },

    //微信支付-JSAPI支付-统一下单
    jsapiUnifiedorderAPI(params) {
        return http.post(`${resquest}/wxPay/jsapi/unifiedorder`, params)
    },

    //获取微信分享配置参数
    shareInfoAPI(params) {
        return http.post(`${resquest}/wx/shareInfo`, params)
    },

    // ***********************微信模块**********************

    //微信授权码回调获取
    getWechatAccessToken(params) {
        storage.setToken('') //设置请求头值
        return http.get(`${resquest}/wx/authorize_return`, params)
    },

    //拉取微信用户信息
    getWechatUserInfo(params) {
        storage.setToken('') //设置请求头值
        return http.get(`${resquest}/wx/userinfo`, params)
    },

    //平台经纪人-查看
    brokerDetailapi(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/pc/dictionaryParameters/setting/broker/detail`, params)
    },

    //用户是否关注公众号
    subscribeAPI(params) {
        return http.post(`${resquest}/wx/subscribe`, params)
    },

    //获取超级会员状态-查看
    getStatus(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/distributorApply/getStatus`, params)
    },
    
    //获取资料详情
    getContractDetail(params) {
        storage.setToken(storage.getUserInfo()) //设置请求头值
        return http.post(`${resquest}/mobile/orderInfo/userH5/supplement/detail`, params)
    },
}


// WEBPACK FOOTER //
// ./src/api/index.js